import { useMutation } from '@tanstack/react-query'
import { sendBroadcast } from '../index'

const useSendBroadcast = () =>
  useMutation({
    mutationFn: sendBroadcast,
  })

export default useSendBroadcast
